import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Cta() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-primary-500">
      <div className="max-w-4xl mx-auto px-4 md:px-6 py-14 md:py-16 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-background-50">
          {t('home.cta.title')}
        </h2>
        <p className="mt-3 text-background-50/90 text-sm md:text-base max-w-xl mx-auto">
          {t('home.cta.subtitle')}
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="mt-7 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-background-50 text-primary-700 text-sm md:text-base font-semibold whitespace-nowrap hover:bg-background-100 transition-colors"
        >
          {t('home.cta.button')}
          <i className="ri-external-link-line"></i>
        </a>
      </div>
    </section>
  );
}